import React from 'react'
import { FaBars, FaTimes } from 'react-icons/fa'
import './MobileMenuButton.css'

const MobileMenuButton = ({ isOpen, onToggle }) => {
  return (
    <button 
      className={`mobile-menu-btn ${isOpen ? 'open' : ''}`}
      onClick={onToggle}
      aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
    >
      <div className="hamburger-icon">
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </div>
    </button>
  )
}

export default MobileMenuButton